import { render, staticRenderFns } from "./ProblemInfo.vue?vue&type=template&id=5f4d9fb8&"
import script from "./ProblemInfo.vue?vue&type=script&lang=js&"
export * from "./ProblemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports